import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { EmployeeService } from '../../services/employees.service';
import { UtilService } from '../../services/util.service';
import {
    Group
} from '../../models/models';

@Component({
    selector: 'employee-group-grid',
    templateUrl: './employee-group-grid.component.html',
    standalone: false
})
export class EmployeeGroupGrid implements OnInit {
    @ViewChild(GridComponent, { static: false }) public tableGrid!: GridComponent;

    public isEdit: boolean = false;
    public isAdd: boolean = false;
    public isAssign: boolean = false;

    public tableID: number = 0;
    public recordName: string = "Employee Group";
    public tableList: Group[] = [];
    private tableIDName: string = "groupId";

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: this.tableIDName }] };

    constructor(private employeeService: EmployeeService, private utilService: UtilService, private dialog: MatDialog, private ngZone: NgZone) {
    }

    ngOnInit() {
        this.getTableList();
    }

    private getTableList() {
        this.utilService.isLoading = true;
        this.employeeService.getAllEmployeeGroups().subscribe(result => {
            this.utilService.isLoading = false;
            this.tableList = result;
            this.setGrid();
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.tableList = orderBy(this.tableList, this.gridState.sort);

        this.gridData = process(this.tableList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.tableGrid == null) return;
            this.tableGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public edit(tableID: number) {
        this.tableID = tableID;
        this.isEdit = true;
        this.isAdd = false;
        this.isAssign = false;
    }

    public assign(tableID: number) {
        this.tableID = tableID;
        this.isEdit = false;
        this.isAdd = false;
        this.isAssign = true;
    }

    public delete(tableID: number) {
        var idx = this.tableList.findIndex(c => c.groupId == tableID);

        if (idx == null || idx < 0) return;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete?',
            message: 'Would you like to delete this ' + this.recordName + '?'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;
        });
    }

    public addNew() {
        this.tableID = 0;
        this.isEdit = false;
        this.isAdd = true;
        this.isAssign = false;
    }

    public cancelEdit() {
        this.isEdit = false;
        this.isAdd = false;
        this.isAssign = false;
        this.getTableList();
    }
}
